import { Tooltip } from '../../../../design-system/Tooltip'
import * as styled from '../../../../util/styled'

const Container = styled.div('')
const ArticleContainer = styled.div('flex flex-row gap-5 mb-4 overflow-hidden')
const ImageContainer = styled.div('flex-none w-24 h-24 bg-black/10 rounded-lg')
const BodyContainer = styled.div('flex-grow flex-shrink flex flex-col gap-2 overflow-hidden')
const HeaderBar = styled.div('flex flex-row gap-5 justify-between overflow-hidden')
const HeaderBarLeft = styled.div('shrink overflow-hidden')
const DomainContainer = styled.div('flex flex-row gap-2')
const Domain = styled.div('text-brand text-sm')
const titleClasses = 'text-brand text-2xl font-semibold whitespace-nowrap overflow-hidden text-ellipsis'
const Title = styled.div(titleClasses)
const TitleLink = styled.anchor([titleClasses, 'hover:underline focus:underline block'])
const Description = styled.div('text-text-secondary text-sm')
const AnalyticsContainer = styled.div('flex flex-row gap-2 justify-between items-center')
const AnalyticsItem = styled.div('flex flex-row gap-2')
const AnalyticsKey = styled.div('text-text-tertiary text-sm')
const AnalyticsValue = styled.div('text-text-primary text-sm font-semibold')
const CTABar = styled.div('flex flex-row gap-2 justify-between shrink-0 my-2')


type Props = {
  className?: string
  image: JSX.Element
  domain: JSX.Element | string
  title: JSX.Element | string
  titleUrl?: string
  description: JSX.Element | string
  analyticsTooltip?: string
  analytics: {
    key: string
    title: JSX.Element | string
    value: JSX.Element | string
  }[]
  cta: JSX.Element
}

export const ResultLayout = (props: Props) => {
  const analticsFragment = (
    <AnalyticsContainer> 
      {props.analytics.map(({ key, title, value }) => (
        <AnalyticsItem key={key}>
          <AnalyticsValue>{value}</AnalyticsValue>
          <AnalyticsKey>{title}</AnalyticsKey>
        </AnalyticsItem>
      ))} 
    </AnalyticsContainer>
  )
  return (
    <Container>
      <CTABar>
        {props.cta}
      </CTABar>
      <ArticleContainer className={props.className}>
        <ImageContainer>{props.image}</ImageContainer>
        <BodyContainer>
          <HeaderBar>
            <HeaderBarLeft>
              <DomainContainer>
                <Domain>{props.domain}</Domain>
                {props.analyticsTooltip && <Tooltip content={props.analyticsTooltip} side='top'>{analticsFragment}</Tooltip>}
                {!props.analyticsTooltip && analticsFragment}
              </DomainContainer>
              {props.titleUrl && <TitleLink target='_blank' rel='noopener noreferrer' href={props.titleUrl}>{props.title}</TitleLink>}
              {!props.titleUrl && <Title>{props.title}</Title>}
            </HeaderBarLeft>
          </HeaderBar>
          <Description>{props.description}</Description>
        </BodyContainer>
      </ArticleContainer>
    </Container> 
  )
}
